import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Initialize language from localStorage immediately
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage');
    // If the saved language is Chinese (zh), default to English
    if (savedLanguage === 'zh') {
      localStorage.setItem('selectedLanguage', 'en');
      return 'en';
    }
    return savedLanguage || 'en';
  });

  const changeLanguage = (languageCode) => {
    console.log('Changing language to:', languageCode);
    setCurrentLanguage(languageCode);
    localStorage.setItem('selectedLanguage', languageCode);
  };

  const value = {
    currentLanguage,
    changeLanguage,
    // Aliases for backward compatibility
    language: currentLanguage,
    setLanguage: changeLanguage
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};